// The functions the menu, toolbar and search offer, and the level each acts at. Kept apart from the function service so
// code that only needs to name them (such as search's rules) doesn't pull in the service and everything it uses
export enum FUNCTION {
    CREATE_PROJECT,
    DELETE_PROJECT,
    CREATE_MODEL,
    REPLACE_CURRENT_STATE,
    CREATE_TAG_GROUP,
    CREATE_ORGANISATION,
    EDIT_ORGANISATION,
    EDIT_MODEL_TAGS,
    EDIT_MODEL_DETAILS,
    EDIT_USER_DETAILS,
    EDIT_PROJECT,
    CANCEL_CHANGES,
    MANAGE_USERS,
    DELETE_MODEL,
    SAVE_MODEL,
    DOWNLOAD_MODEL,
    ZOOM_IN,
    ZOOM_OUT,
    FIT_TO_SCREEN,
    RETURN_TO_ORIGINAL,
    CUT,
    COPY,
    PASTE,
    UNDO,
    REDO,
    COLLAPSE_ALL,
    EXPAND_ALL,
    REMOVE_GROUPS,
    CREATE_GROUPS,
    RESET_LAYOUT,
    TOGGLE_VIEW_DIRECTION,
    MANAGE_LABELS,
    RECALCULATE_INSIGHTS,
    APPLY_FILTER,
    CLEAR_FILTER,
    TOGGLE_INSIGHTS,
    TOGGLE_LEFT_PANE,
    SELECT_TAG,
    REMOVE_TAGS,
    GROUP_SELECTION,
    UNGROUP_SELECTION,
    PAY_SUBSCRIPTION,
    LOGOUT,
    BACKUP_MODEL,
    RESTORE_BACKUP,
    RESTORE_MODEL,
    MERGE_NODES,
    REQUEST_ACCESS,
    SWITCH_TO_PAN_MODE,
    SWITCH_TO_SELECT_MODE,
    CREATE_TICKET,
    MOVE_SELECTION_TO_MODEL,
    MAINTAIN_EMISSION_FACTOR,
    DELETE_EMISSION_FACTOR,
    CHANGE_MODEL_TYPE,
    SHOW_HELP_GUIDE,
    REFRESH_INSIGHTS,
    OPEN_MODELLING_AI,
    CLOSE_ORGANISATION,
    TOGGLE_TEMPORAL_MODEL,
    SCREEN_TOUR,
    TOGGLE_MAGNIFYING_GLASS,
    TOGGLE_HEATMAP,
    CHANGE_LAYOUT,
    INCREMENTAL_LAYOUT,
    COMPARE_WITH_CURRENT_STATE      // a project's model overlaid on the same model in current state
}

export enum FUNCTION_LEVEL {
    SYSTEM,
    ORGANISATION,
    PROJECT,
    MODEL,
    NODE
}
